export const OverflowMenuStorefrontCacheModule = angular
    .module('app.components.pageHeader.overflowStorefrontCache', [])
    .component('overflowMenuStorefrontCache', {
        template: `
            <md-menu-item class="overflow-menu-storefront-cache">
                <md-button aria-label="Storefront Cache Refresh Button" ng-click="$ctrl.onRefreshCache()">
                        <span translate="BUTTON.STOREFRONTCACHE"></span>
                </md-button>
            </md-menu-item>
        `,
        bindings: {
            onRefreshCache: '<'
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/pageHeader/overflowMenu/overflowMenuStorefrontCache.js